import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getWorkflow, getWorkflowArchive } from "services/workflows";
// components
import NodeGraph from "components/Workflows/NodeGraph";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  .selectedView {
    font-weight: bold;
  }

  .view {
    cursor: pointer;
  }

  .view:hover {
    text-decoration: underline;
  }
`;

const WorkflowGraph = () => {
  const { workflow_id, archive_id } = useParams();
  console.log("!!! WORKFLOW GRAPH PARAMS: ", workflow_id, archive_id);
  const navigate = useNavigate();

  const [workflow, setWorkflow] = useState(null);
  const [archive, setArchive] = useState(null);

  useEffect(() => {
    window.document.body.classList.add("overflow-hidden");

    return () => {
      window.document.body.classList.remove("overflow-hidden");
    };

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("!!! WORKFLOW ID: ", workflow_id);
    console.log("!!! ARCHIVE ID: ", archive_id);
    if (archive_id) {
      const loadArchive = async () => {
        const workflow = await getWorkflowArchive(archive_id);
        console.log("!!! LOADED ARCHIVE WORKFLOW: ", workflow);
        setArchive(true);
        setWorkflow(workflow);
      };
      loadArchive();
    } else if (workflow_id) {
      const loadWorkflow = async () => {
        const workflow = await getWorkflow(workflow_id);
        console.log("!!! LOADED WORKFLOW: ", workflow);
        setWorkflow(workflow);
        setArchive(false);
      };
      loadWorkflow();
    }

    // eslint-disable-next-line
  }, [workflow_id, archive_id]);

  useEffect(() => {
    //dispatch(clearWorkflow());
    if (workflow) {
      window.history.replaceState(
        null,
        "Edit Workflow",
        `/admin/workflow/${workflow.public_id}/graph`
      );
    } else if (!workflow_id) {
      window.history.replaceState(null, "New Workflow", "/workflow");
    }

    // eslint-disable-next-line
  }, [workflow]);

  if (!workflow) {
    return (
      <div>
        <GlobalStyle />
        <div
          className="relative md:ml-64 bg-blueGray-100 pt-8"
          style={{ height: "100%", minHeight: "100vh", zIndex: 30 }}
        >
          <div style={{ marginLeft: "50px" }}>Loading Graph...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <GlobalStyle />
      <div>
        <NodeGraph
          workflow={workflow}
          archive={archive}
          onClose={() => {
            navigate(`/admin/workflow/${workflow.public_id}`);
          }}
        />
      </div>
    </div>
  );
};

export default WorkflowGraph;
